import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@repo/design-system/components/ui/drop-down-menu";
import { cn } from "@repo/design-system/utils/cn";
import { getCanonicalUrl } from "@repo/design-system/utils/helpers";
import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
import { LinkedInIcon } from "../icons/linkedin-eon";
import { MailIcon } from "../icons/mail-eon";
import { ShareIcon } from "../icons/share-eon";
import { XingIcon } from "../icons/xing-eon";
import { Button, type ButtonProps } from "./button-eon";
export default function ShareDropdown(t0) {
  const $ = _c(36);
  const {
    job,
    children,
    className,
    variant
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job) {
    const canonicalUrl = getCanonicalUrl(job);
    t1 = canonicalUrl.replace("=", "%3D");
    $[0] = job;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cleanHref = t1;
  let t2;
  if ($[2] !== job.data.title) {
    t2 = job.data.title.replace("&", "and");
    $[2] = job.data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cleanTitle = t2;
  const t3 = `mailto:?subject=Job "${cleanTitle}" (Job-ID: ${job.data.jobNumber})&body=${cleanHref}`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MailIcon className="size-5 text-black group-hover:text-white" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t.jobad_share_mail || $[6] !== t3) {
    t5 = {
      platform: "mail",
      href: t3,
      icon: t4,
      text: t.jobad_share_mail
    };
    $[5] = t.jobad_share_mail;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `https://www.linkedin.com/sharing/share-offsite/?url=${cleanHref}`;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LinkedInIcon className="size-5 text-black group-hover:text-white" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t.jobad_share_linkedin || $[10] !== t6) {
    t8 = {
      platform: "linkedin",
      href: t6,
      icon: t7,
      text: t.jobad_share_linkedin
    };
    $[9] = t.jobad_share_linkedin;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `https://www.xing.com/spi/shares/new?url=${cleanHref}`;
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <XingIcon className="size-5 text-black group-hover:text-white" />;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t.jobad_share_xing || $[14] !== t9) {
    t11 = {
      platform: "xing",
      href: t9,
      icon: t10,
      text: t.jobad_share_xing
    };
    $[13] = t.jobad_share_xing;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5 || $[18] !== t8) {
    t12 = [t5, t8, t11];
    $[16] = t11;
    $[17] = t5;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const socialShare = t12;
  let t13;
  if ($[20] !== className) {
    t13 = cn("group w-full gap-2", className);
    $[20] = className;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== children) {
    t14 = children ? children : <><ShareIcon className="size-6 stroke-2" /><ChevronDown className="size-6 stroke-2 duration-200 ease-in-out group-data-[state=open]:rotate-180" /></>;
    $[22] = children;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t.jobad_share_title) {
    t15 = <span className="sr-only">{t.jobad_share_title}</span>;
    $[24] = t.jobad_share_title;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== variant) {
    t16 = <DropdownMenuTrigger asChild={true}><Button className={t13} variant={variant}>{t14}{t15}</Button></DropdownMenuTrigger>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = variant;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== socialShare) {
    t17 = <DropdownMenuContent align="end" className="w-full">{socialShare.map(_temp)}</DropdownMenuContent>;
    $[31] = socialShare;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <DropdownMenu>{t16}{t17}</DropdownMenu>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
}
function _temp(social) {
  return <DropdownMenuItem asChild={true} key={social.href}><CustomLink blank={true} className="group flex items-center gap-3 hover:bg-secondary!" href={social.href}>{social.icon}<span>{social.text}</span></CustomLink></DropdownMenuItem>;
}